import {
    FC,
    FormEvent,
    ReactElement,
    useState,
} from 'react'

import {
    Button,
    InfoListItem,
    LoadingSpinner,
    Select,
} from '@/components'
import { GENDERS } from '@/constants'
import { trans } from '@/helpers/trans'
import { FormOption } from '@/types'

import '@/containers/@forms/ProfileDetailForm/ProfileDetailForm.scss'

interface ProfileDetailSelectFormProps {
    title: string
    propName: string
    value?: string
    options: FormOption[]
    onSave: (value: string) => void
    intro?: string | null
    loading: boolean
}

export const ProfileDetailSelectForm: FC<ProfileDetailSelectFormProps> = ({
    title,
    propName,
    value: initialValue,
    options,
    onSave,
    intro = null,
    loading,
}): ReactElement => {
    // Only the initial value is used, later changes of the prop aren't picked up
    const [value, setValue] = useState(initialValue || GENDERS[0].value)

    const onFormSubmit = (event: FormEvent): void => {
        event.preventDefault()
        onSave(value)
    }

    return (
        <form
            className="profile-page-detail"
            onSubmit={onFormSubmit}
        >
            <div className="profile-page-detail__header">
                {title}
            </div>
            { intro && (
                <div className="profile-page-detail__intro">
                    {intro}
                </div>
            )}
            <ul className="profile-page-detail__list-group">
                <InfoListItem
                    label={propName}
                    className="profile-page-detail__item"
                >
                    <Select
                        label={title}
                        options={options}
                        value={value}
                        onChange={setValue}
                        className={`profile-page-detail__select ${propName ? '' : 'profile-page-detail__select--full-width'}`}
                    />
                </InfoListItem>
            </ul>
            <div className="profile-page-detail__save-button-wrapper">
                <Button
                    disabled={value === null}
                    text={trans('common.save')}
                    type="submit"
                    className="profile-page-detail__save-button"
                />
            </div>
            {loading && <LoadingSpinner />}
        </form>
    )
}
